import { config as variantConfig } from '@/pageConfig/home/us/bottom-sticky-cta';
import { HomePageTemplate } from '@/pageTemplate/HomePageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function HomeSwapReviewsProductsVariant() {
  const { trackEvent, trackDataForGtm } = useAnalyticsContext();
  useEffect(() => {
    trackEvent('home_page.viewed', {
      experiment: 'bottom_sticky_cta_on',
    });
    trackDataForGtm('homepage_viewed');
  }, []);

  return <HomePageTemplate config={variantConfig} />;
}
